import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import {
  setErrorStatus,
  errorRedirect as errorRedirectAction,
  setError,
  logout,
} from '../actions';
import { ERROR } from '../constants/routes';

import { SERVER_ERROR, EXCEPTION, FORBIDDEN } from '../constants/errorStatuses';
import * as messageTypes from '../constants/messageTypes';
import * as toastr from '../utils/toastr';

export function* errorRedirect({ payload }) {
  yield put(setErrorStatus(payload));
  yield put(push(ERROR));
}

export function* handleError({ payload: err }) {
  yield put(setError(err));
  if (err.status >= 500) {
    yield put(errorRedirectAction(SERVER_ERROR));
  } else if (err.status === FORBIDDEN) {
    yield put(setErrorStatus(err.status));
    yield put(logout());
  } else if (!err.message) {
    yield put(errorRedirectAction(EXCEPTION));
  } else {
    return put(toastr.error(messageTypes.ERROR, err.message));
  }
}
